// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "front_assets/js/" + (chunkId === 202 ? "code95Configurator" : chunkId) + "." + {"202":"06218be0a8625cad9b72","260":"162970699e02225fa96a","728":"d4a301888b5c769bdf49"}[chunkId] + ".js";
};